// 구직.js
import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import "../css/BoardList.css";
import "../css/JobBoardList.css";

const JobSeekers = () => {
  const [posts, setPosts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const postsPerPage = 10; // 페이지당 게시물 수
  const pageLimit = 5; // 페이지 그룹당 표시할 페이지 수

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          "https://jsonplaceholder.typicode.com/posts"
        );
        const enrichedData = response.data.map((post, index) => ({
          id: post.id,
          title: post.title,
          author: `사용자${(index % 5) + 1}`,
          date: `2024-10-${10 - (index % 5)}`,
          views: Math.floor(Math.random() * 100),
        }));
        setPosts(enrichedData);
        setLoading(false);
      } catch (err) {
        setError("데이터를 불러오는 데 실패했습니다.");
        setLoading(false);
      }
    };

    fetchPosts();
  }, []);

  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = posts.slice(indexOfFirstPost, indexOfLastPost);

  const totalPages = Math.ceil(posts.length / postsPerPage);
  const [currentPageGroup, setCurrentPageGroup] = useState(1);
  const totalPageGroups = Math.ceil(totalPages / pageLimit);

  const getPageNumbers = () => {
    const start = (currentPageGroup - 1) * pageLimit + 1;
    const end = Math.min(start + pageLimit - 1, totalPages);
    return Array.from({ length: end - start + 1 }, (_, i) => start + i);
  };

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const goToNextPageGroup = () => {
    if (currentPageGroup < totalPageGroups) {
      setCurrentPageGroup(currentPageGroup + 1);
      setCurrentPage((currentPageGroup + 1 - 1) * pageLimit + 1);
    }
  };

  const goToPreviousPageGroup = () => {
    if (currentPageGroup > 1) {
      setCurrentPageGroup(currentPageGroup - 1);
      setCurrentPage((currentPageGroup - 1) * pageLimit + 1);
    }
  };

  if (loading) return <p>로딩 중...</p>;
  if (error) return <p>{error}</p>;

  return (
    <div className="board-list">
      <h1>구직 게시판</h1>
      <div>
        <Link to="/jobpostings">
          <button>구인</button>
        </Link>
        <Link to="/jobseekers">
          <button>구직</button>
        </Link>
      </div>
      <table className="board-table">
        <thead>
          <tr>
            <th>번호</th>
            <th>제목</th>
            <th>작성자</th>
            <th>작성일</th>
            <th>조회수</th>
          </tr>
        </thead>
        <tbody>
          {currentPosts.map((post) => (
            <tr key={post.id}>
              <td>{post.id}</td>
              <td>
                <Link to={`/board/${post.id}`}>{post.title}</Link>
              </td>
              <td>{post.author}</td>
              <td>{post.date}</td>
              <td>{post.views}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="pagination">
        <button
          className="pagination-button"
          onClick={goToPreviousPageGroup}
          disabled={currentPageGroup === 1}
        >
          &lt;
        </button>
        {getPageNumbers().map((number) => (
          <button
            key={number}
            onClick={() => paginate(number)}
            className={`pagination-button ${
              number === currentPage ? "active" : ""
            }`}
          >
            {number}
          </button>
        ))}
        <button
          className="pagination-button"
          onClick={goToNextPageGroup}
          disabled={currentPageGroup === totalPageGroups}
        >
          &gt;
        </button>
      </div>

      <Link to="/board/new" className="new-post-link">
        새 글 작성
      </Link>
    </div>
  );
};

export default JobSeekers;
